import type { JobPost } from '~/api/jobPosts/types';

import { Avatar } from '~/components';

export const JobPostClientLogo = ({ jobPost }: { jobPost: JobPost }) => {
  return <Avatar fallback={jobPost.clientName.charAt(0)} src={jobPost.logoUrl ?? undefined} />;
};
